<template>
  <mdb-container fluid>
    <mdb-row>
      <mdb-col xl="3" md="6" class="mb-4">
        <mdb-card cascade class="cascading-admin-card">
          <div class="admin-up hover" @click="showAllTransactions">
            <div class="data">
              <p>کیف پول</p>
              <h3 class="font-weight-bold dark-grey-text break-word">
                <span>{{dashboard.WalletAmount | commaDigit}}</span><br> تومان
              </h3>
            </div>
            <i class="fas fa-money-bill primary-color"></i>
          </div>

          <mdb-card-body cascade>
            <p class="card-text">
              <span v-text="dashboard.ProfitAmount"></span> اعتبار مالی
            </p>
          </mdb-card-body>
        </mdb-card>
      </mdb-col>

      <mdb-col xl="3" md="6"
        class="mb-4 ">
        <mdb-card cascade class="cascading-admin-card">
          <div class="admin-up hover" @click="showAllInvoice">
            <i class="fas fa-chart-line warning-color"></i>
            <div class="data">
              <p>صورت حساب</p>
              <h3 class="font-weight-bold dark-grey-text">
                <span v-text="dashboard.NewInvoiceCount"></span><br> جدید
              </h3>
            </div>
          </div>

          <mdb-card-body cascade>
            <p class="card-text">
              <span v-text="dashboard.InvoiceCount"></span> صورت حساب های کل
            </p>
          </mdb-card-body>
        </mdb-card>
      </mdb-col>

      <mdb-col xl="3" md="6" class="mb-4">
        <mdb-card cascade class="cascading-admin-card">
          <div class="admin-up hover" @click="showAllTicket">
            <i class="fas fa-chart-pie light-blue lighten-1"></i>
            <div class="data">
              <p>تیکت ها</p>
              <h3 class="font-weight-bold dark-grey-text">
                <span v-text="dashboard.TicketNewCount"></span><br> باز
              </h3>
            </div>
          </div>

          <mdb-card-body cascade>
            <p class="card-text">
              <span v-text="dashboard.TicketCount"></span> کل
            </p>
          </mdb-card-body>
        </mdb-card>
      </mdb-col>

      <mdb-col xl="3" md="6" class="mb-4">
        <mdb-card cascade class="cascading-admin-card">
          <div class="admin-up hover" @click="showAllService">
            <i class="fas fa-chart-bar red accent-2"></i>
            <div class="data">
              <p>سرویس ها</p>
              <h3 class="font-weight-bold dark-grey-text">
                <span v-text="dashboard.ActiveServiceCount"></span><br> فعال
              </h3>
            </div>
          </div>

          <mdb-card-body cascade>
            <p class="card-text">
              <span v-text="dashboard.ServiceCount"></span> سرویس های کل
            </p>
          </mdb-card-body>
        </mdb-card>
      </mdb-col>
    </mdb-row>

    <mdb-row>
      <mdb-col lg="6" md="12">

        <mdb-card class="mb-4">
          <div class="card-header white-text danger-color">سفارش جدید</div>
          <div class="card-body">
            <div class="row">
            <mdb-select
              v-if="services!=null && services != []"
              search
              label="لطفا سرویس جدیدتان را انتخاب کنید"
              :options="services"
              searchPlaceholder="جستجو"
              :required="true"
              class="col-12 col-md-8"
              @change="selectService"
            />
            
            <mdb-btn
              color="danger col-4 col-md-3"
              @click="requestService"
              :disabled="!canRequestService"
              size="lg">ادامه</mdb-btn>
            </div>
            <div v-show="serviceType == 1">
              <mdb-modal-body  class="row">
                <mdb-input
                      placeholder="برسی دامنه ای که می خواهید ثبت نمایید"
                      label="دامنه"
                      labelColor="white"
                      v-model="whois.Domain"
                      @change="domainChange"
                      class="req v-input--is-label-active col-8 col-md-8"
                    />
                <mdb-btn
                  @click="checkWhois"
                  :disabled="invalidDomain"
                  color="info col-3 col-md-3"
                  size="lg">برسی</mdb-btn>
              </mdb-modal-body>
              <div class="alert alert-danger" v-show="whoisDangerMessage" v-text="whoisDangerMessage">

              </div>
              <div class="alert alert-success" v-show="whoisSuccessMessage" v-text="whoisSuccessMessage">

              </div>
            </div>
          </div>
        </mdb-card>

        <mdb-card class="mb-4">
          <div class="card-header white-text primary-color">آخرین تیکت ها</div>
          <div class="card-body">
            <table class="table no-header mt-1">
              <tbody>
                <tr
                  v-for="ticket in dashboard.TicketTop"
                  v-bind:key="ticket.TicketId"
                  @click="showTicket(ticket)"
                  class="hover"
                >
                  <td v-text="ticket.DepartmentName"></td>
                  <td v-text="ticket.Title"></td>
                  <td class="hour">
                    <small>
                      <span class="grey-text float-right notification-clock">
                        <i class="far fa-clock" aria-hidden="true"></i>
                        <span v-text="ticket.LastUpdate"></span>
                      </span>
                    </small>
                  </td>
                </tr>
              </tbody>
            </table>

            <mdb-btn
              dark-waves
              flat
              rounded
              @click="showAllTicket"
              class="grey lighten-3 float-right font-weight-bold dark-grey-text"
              >نمایش همه</mdb-btn>
          </div>
        </mdb-card>

        <div class="card mb-4">
          <div class="card-header white-text warning-color">اعتبار سرویس</div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th class="font-weight-bold dark-grey-text">وضعیت</th>
                    <th class="font-weight-bold dark-grey-text">عنوان</th>
                    <th class="font-weight-bold dark-grey-text">سرسید</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="service in dashboard.ServiceExpiration"
                    v-bind:key="service.ServiceId"
                  >
                    <td>
                      <span :class="'badge ' + service.Status"
                        >&nbsp;&nbsp;&nbsp;&nbsp;</span
                      >
                    </td>
                    <td v-text="service.Name"></td>
                    <td class="hour">
                      <small>
                        <span class="grey-text">
                          <i class="far fa-clock" aria-hidden="true"></i>
                          <span v-text="service.LastUpdate"></span>
                        </span>
                      </small>
                    </td>
                  </tr>
                </tbody>
              </table>

              <mdb-btn
                dark-waves
                flat
                rounded
                @click="showAllService"
                class="grey lighten-3 float-right font-weight-bold dark-grey-text">نمایش همه</mdb-btn>

            </div>
          </div>
        </div>

        <!-- /.Panel -->
      </mdb-col>

      <!-- /.First column -->

      <div class="col-lg-6 col-md-12">
        <!--Panel-->
        <div class="card mb-4">
          <div class="card-header white-text primary-color">
            آخرین فاکتورهای صادر شده
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th class="font-weight-bold dark-grey-text">
                      شماره فاکتور
                    </th>
                    <th class="font-weight-bold dark-grey-text">عنوان</th>
                    <th class="font-weight-bold dark-grey-text">مبلغ</th>
                    <th class="font-weight-bold dark-grey-text">صدور</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="invoice in dashboard.InvoiceTop"
                    :data-status="invoice.Status"
                    :data-pay-status="invoice.PayStatus"
                    v-bind:key="invoice.InvoiceId"
                    :class="[(invoice.Status == 1 && invoice.PayStatus == 0) ?'bg-le-info hover':invoice.Status == 2 && invoice.PayStatus == 0?'bg-le-warning hover':invoice.Status == 3 && invoice.PayStatus == 0?'bg-le-danger  hover':' hover'] "
                    @click="showInvoice(invoice)"
                  >
                    <td v-text="invoice.Number"></td>
                    <td v-text="invoice.Name"></td>
                    <td>{{invoice.TotalPay | commaDigit}}</td>
                    <td class="hour">
                      <small>
                        <span class="grey-text">
                          <i class="far fa-clock" aria-hidden="true"></i>
                          <span v-text="invoice.FirstUpdate"></span>
                        </span>
                      </small>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <mdb-btn
              dark-waves
              flat
              rounded
              @click="showAllInvoice"
              class="grey lighten-3 float-right font-weight-bold dark-grey-text">نمایش همه</mdb-btn>
          </div>
        </div>

        <section class="mt-lg-5">
          <div class="row">
            <div
              v-for="userPackage in dashboard.Packages"
              v-bind:key="userPackage.PackageId"
              class="col-lg-6 col-md-12 mb-4"
            >
              <div class="card card-cascade narrower">
                <div
                  :class="
                    'view view-cascade gradient-card-header ' +
                    (userPackage.SpecialSale
                      ? ' danger-color '
                      : ' info-color ')
                  "
                >
                  <h4
                    class="mb-0"
                    v-text="
                      'پیشنهاد' +
                      (userPackage.SpecialSale ? ' ویژه خرید ' : ' خرید ') +
                      userPackage.Title
                    "
                  ></h4>
                </div>

                <div class="card-body card-body-cascade text-center">
                  <div class="list-group list-panel">
                    <a
                      v-for="packageDetail in userPackage.PackageDetails"
                      v-bind:key="packageDetail.PackageDetailId"
                      :href="'#buy-' + userPackage.PackageId"
                      class="
                        list-group-item
                        d-flex
                        justify-content-between
                        dark-grey-text
                      "
                    >
                      <span v-text="packageDetail.Name"></span>&nbsp;
                      <span v-text="packageDetail.Count"></span>&nbsp;
                      <span v-text="packageDetail.Unit"></span>&nbsp;
                      <!-- <i class="fas fa-wrench ml-auto"
                        data-toggle="tooltip"
                        data-placement="top"
                        title=""></i> -->
                    </a>
                  </div>
                  <button
                    :id="'#buy-' + userPackage.PackageId"
                    @click="userPackage.Details = true"
                    class="
                      btn btn-outline-info
                      waves-effects
                      ml-auto
                      col-12
                      m-0
                    "
                  >
                    بیشتر
                  </button>

                  <mdb-modal
                    size="success"
                    position="notify"
                    :show="userPackage.Details == true"
                    @close="userPackage.Details = false"
                  >
                    <mdb-modal-header class="text-white">
                      <p
                        class="heading lead"
                        v-text="
                          'پیشنهاد' +
                          (userPackage.SpecialSale ? ' ویژه خرید ' : ' خرید ') +
                          userPackage.Title
                        "
                      ></p>
                    </mdb-modal-header>

                    <mdb-modal-body class="text-center">
                      <mdb-icon
                        icon="check"
                        size="4x"
                        class="mb-3 animated rotateIn"
                      ></mdb-icon>
                      <p v-text="userPackage.Description"></p>
                    </mdb-modal-body>

                    <mdb-modal-footer class="justify-content-center">
                      <mdb-btn color="success" @click="orderPackage(userPackage)">
                        سفارش میدم
                        <i class="fas fa-gem text-white ml-1"></i>
                      </mdb-btn>
                      <mdb-btn
                        outline="success"
                        @click.native="userPackage.Details = false"
                        >برای من مناسب نیست</mdb-btn
                      >
                    </mdb-modal-footer>
                  </mdb-modal>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div class="card mb-4">
          <div class="card-header white-text success-color">اخرین اخبار</div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table">
                <tbody>
                  <tr
                    v-for="announcement in dashboard.Announcements"
                    v-bind:key="announcement.AnnouncementId"
                  >
                    <td>
                      <a :href="'/Announcements/'+announcement.AnnouncementId" v-text="announcement.Title"></a>
                    </td>
                  </tr>
                </tbody>
              </table>

              <mdb-btn
                dark-waves
                flat
                rounded
                @click="showAllAnnouncement"
                class="grey lighten-3 float-right font-weight-bold dark-grey-text">نمایش همه</mdb-btn>

            </div>
          </div>
        </div>

      </div>
    </mdb-row>
  </mdb-container>
</template>

<script>
import systemApi from "@/api/systemApi";
import domainApi from "@/api/domainApi";

const userDashboard = () => ({
  WalletAmount: 0,
    ProfitAmount: 0,
    TicketCount: 0,
    TicketNewCount: 0,
    TicketTop: null,
    ServiceCount: 0,
    ActiveServiceCount: 0,
    InvoiceCount: 0,
    NewInvoiceCount: 0,
    InvoiceTop: null,
    Packages: null,
    ServiceType: null,
    BankAccounts: null
});

import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardBody,
  mdbBtn,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbIcon,
  mdbInput,
  mdbTextarea,
  mdbTab,
  mdbTabItem,
  mdbSelect,
} from "mdbvue";

export default {
  name: "Dashboard",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardBody,
    mdbBtn,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbIcon,
    mdbInput,
    mdbTextarea,
    mdbTab,
    mdbTabItem,
    mdbSelect,
  },
  data() {
    return {
      dashboard: userDashboard(),
      services: null,
      serviceType: 1,
      canRequestService: true,
      whois: {
        Domain : ''
      },
      invalidDomain: true,
      whoisDangerMessage:'',
      whoisSuccessMessage:'',
    };
  },
  methods: {
    showAllTicket() {
      this.$router.push({ name: "Tickets" });
    },
    showAllInvoice() {
      this.$router.push({ name: "Invoices" });
    },
    showAllService() {
      this.$router.push({ name: "Services" });
    },
    showAllTransactions() {
      this.$router.push({ name: "Wallet" });
    },
    showAllAnnouncement() {
      this.$router.push({ name: "Announcements" });
    },
    showTicket(ticket){
      this.$router.push({name: 'Ticket', params: { ticketId: ticket.TicketId }});
    },
    showInvoice(invoice){
      // console.log("invoice",invoice);
      this.$router.push({name: 'Invoice', params: { invoiceId: invoice.InvoiceId }});
    },
    orderPackage(userPackage){
      this.$router.push({name: 'Request', params: { type: 'Package', id:userPackage.PackageId }});
    },
    selectService(value,text) {
      this.serviceType = value;
      if(this.serviceType == 1) {
        this.canRequestService = true;
      }else{
        this.canRequestService = true;
      }
      // console.log(value, text);
    },
    requestService(){
      this.$router.push({name: 'Request', params: { type: "Service",id:this.serviceType}});
    },
    isValidDomain(domain) {
      // تبدیل دامنه به حروف کوچک
      domain = domain.toLowerCase();

      // بررسی اینکه دامنه دارای کاراکترهای مجاز است
      const domainPattern = /^[a-z0-9-]+(\.[a-z]{2,})+$/;

      // دامنه نباید با خط تیره شروع یا تمام شود
      if (domain.startsWith('-') || domain.endsWith('-')) {
        return false;
      }

      // بررسی طول دامنه (حداقل 1 و حداکثر 63 کاراکتر برای هر بخش)
      const domainParts = domain.split('.');
      if (domainParts.some(part => part.length < 1 || part.length > 63)) {
        return false;
      }

      // بررسی تطابق با الگوی دامنه
      return domainPattern.test(domain);
    },
    domainChange(){
      if(this.isValidDomain(this.whois.Domain)){
        this.invalidDomain = false;
      }else{
        this.invalidDomain = true;
      }
    },
    checkWhois(){
      this.whoisSuccessMessage = "";
      this.whoisDangerMessage = "";
      this.$toastr.w("در حال برسی دامنه هستیم لطفا منتظر باشید", "برسی دامنه");
      this.invalidDomain = true;
      domainApi.whois(this.whois).then(
              ({ data }) => {
                this.invalidDomain = false;
                // console.log('data',data);
                if(data.error && data.registered == false){
                  this.whoisSuccessMessage = "به نظر میرسد قابل ثبت باشد";
                  this.$toastr.s(this.whoisSuccessMessage, "برسی دامنه");
                }
                else if(data.registered == true){
                  this.whoisDangerMessage = "قبلا ثبت شده است";
                  this.$toastr.e(this.whoisDangerMessage, "برسی دامنه");
                }
                else {
                  this.whoisSuccessMessage = "به نظر میرسد قابل ثبت باشد";
                  this.$toastr.s(this.whoisSuccessMessage, "برسی دامنه");
                }
              },
              (r) => {
                this.invalidDomain = false;
                console.error(r);
              }
            );
    }
  },
  mounted() {
    console.log("mounted");
    this.dashboard = this.$store.state.dashboard;
    systemApi.getDashboard().then(
      ({ data }) => {
        this.$store.state.dashboard = data;
        this.dashboard = this.$store.state.dashboard;

        this.services = [];
        for(var i = 0; i < this.dashboard.ServiceType.length; i++) {
          this.services.push({
            text: this.dashboard.ServiceType[i].Text,
            value: this.dashboard.ServiceType[i].Value,
            selected: this.dashboard.ServiceType[i].Value == this.serviceType
          });
        }
      },
      (r) => {}
    );
  },
};
</script>

<!-- Add 'scoped" attribute to limit CSS to this component only -->
<style scoped>
.m-0 {
  margin: 0;
}
</style>
